import React, { useState } from 'react';
import './BookingForm.css';

const BookingForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    age: '',
    gender: '',
    mobile: '',
    email: '',
    date: '',
    timeSlot: '2:30 PM'
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = () => {
    console.log('Form submitted:', formData);
    alert('Call booked successfully!');
  };

  return (
    // <div className="main-content">
      // <div className="main-card">
        <div className="booking-form-container">
          <div className="booking-form-header">
            <h1 className="booking-form-title">
              Book Your Free 15-Min<br />
              Discovery Call Today
            </h1>
            <p className="booking-form-subtitle">
              Begin with a no-cost call with our counselor. They'll assess your<br />
              needs to precisely match you with a certified psychiatrist who<br />
              specializes in providing the support you're seeking.
            </p>
          </div>
          
          <div className="form-container">
            <div className="form-row form-flex">
              {/* Left Column */}
              <div className="form-left">
                <div className="input-group">
                  <input
                    type="text"
                    name="name"
                    placeholder="Name"
                    value={formData.name}
                    onChange={handleInputChange}
                    className="input"
                  />
                </div>
                <div className="input-group">
                  <input
                    type="number"
                    name="age"
                    placeholder="Age"
                    value={formData.age}
                    onChange={handleInputChange}
                    className="input"
                  />
                </div>
                <div className="input-group">
                  <select
                    name="gender"
                    value={formData.gender}
                    onChange={handleInputChange}
                    className="input"
                  >
                    <option value="">Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                    <option value="prefer-not-to-say">Prefer not to say</option>
                  </select>
                </div>
                <div className="input-group">
                  <input
                    type="tel"
                    name="mobile"
                    placeholder="Mobile Number"
                    value={formData.mobile}
                    onChange={handleInputChange}
                    className="input"
                  />
                </div>
                <div className="input-group">
                  <input
                    type="email"
                    name="email"
                    placeholder="Mail Id"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="input"
                  />
                </div>
              </div>
              {/* Right Column */}
              <div className="form-right">
                <h3 className="time-slot-title">Select the conformable date and time slot</h3>
                <div className="time-slot-row">
                  <input
                    type="date"
                    name="date"
                    value={formData.date}
                    onChange={handleInputChange}
                    className="date-input"
                  />
                  <div className="available-slots">
                    <p className="available-slots-label">Available Slots</p>
                    <div
                      className={`time-slot${formData.timeSlot === '2:30 PM' ? ' selected' : ''}`}
                      onClick={() => setFormData({ ...formData, timeSlot: '2:30 PM' })}
                    >
                      2:30 PM
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
            <div className="submit-row">
                  <button onClick={handleSubmit} className="confirm-button">
                    Confirm the Call
                  </button>
                </div>
          </div>
        </div>
      // </div>
    // </div>
  );
};

export default BookingForm;